import api from '../../axiosInstance';
import { ensureCsrfToken } from '../../utils/csrfUtils';

/**
 * 로그인 로그 조회 API
 * @param {Object} params 
 * @param {number} params.page - 페이지 번호 (1부터 시작)
 * @param {number} params.size - 한 페이지당 데이터 개수
 * @param {string} params.searchKeyword - 검색어 (userid, ip 등)
 * @param {string} params.category - 카테고리 (ex. '전체', 'userid', 'ip')
 * @param {string} params.status - 로그인 성공 상태 ('전체', '성공', '실패')
 * @returns {Promise<Array>} 로그인 로그 배열 (content)
 */
export const getLoginLogs = async ({
  page = 1,
  size = 30,
  searchKeyword = '',
  category = '전체',
  status = '전체',
} = {}) => {
  console.log('[adminApi] 관리자 로그인 로그 조회 API 호출', { page, size, searchKeyword, category, status });

  const res = await api.get('/api/admin/loginlog/list', {
    params: { page, size, searchKeyword, category, status },
  });

  console.log('[adminApi] 로그인 로그 조회 응답:', res.data);

  // res.data.data = LoginLogPagination 객체
  // LoginLogPagination.content 안에 실제 로그 배열 있음
  return res.data.data;
};


// 로그인 로그 일괄 삭제
export const deleteLoginLogs = async (loginLogIds) => {
  console.log('[adminApi] 로그인 로그 일괄 삭제 API 호출 - loginLogIds:', loginLogIds);

  await ensureCsrfToken();

  const res = await api.delete('/api/admin/loginlog/bulk', {
    withCredentials: true,
    data: loginLogIds,
  });

  console.log('[adminApi] 로그인 로그 일괄 삭제 응답:', res.status);
  return res;
};
